import type { QueryClient } from '@tanstack/react-query'
import { createRouter as createTanStackRouter } from '@tanstack/react-router'

import { DefaultErrorPage } from '@/components/default-error-page'
import { DefaultNotFoundPage } from '@/components/default-not-found-page'

import { queryClient } from './query-client'
import { routeTree } from './route-tree.gen'
import { store } from './store'

export type RouterContext = {
  queryClient: QueryClient
  app: 'gw-affiliates'
}

export function createRouter() {
  store.getState().initialize().catch(console.error)

  const router = createTanStackRouter({
    routeTree,
    defaultPreload: 'intent',
    scrollRestoration: true,
    defaultErrorComponent: DefaultErrorPage,
    defaultNotFoundComponent: DefaultNotFoundPage,
    context: { queryClient, app: 'gw-affiliates' },
  })

  store.subscribe(
    (state) => ({
      isAuthorized: state.isAuthorized,
      isInitialized: state.isInitialized,
      partner: state.partner,
    }),
    () => {
      router.invalidate().catch(console.error)
    },
  )

  return router
}

declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- TanStack Router augments via interface, not type alias; oxlint rule conflicts (see no-restricted-imports parity).
  interface Register {
    router: ReturnType<typeof createRouter>
  }
}
